// HomePage.js

import React, { useEffect } from 'react';
import Header from './Header';
import Menu from './Menu';
import Presentation from './Presentation';
import Contact from './Contact';
import '../styles/Home-style.css';
import '../styles/MenuStyle.css';

const HomePage = () => {
    return (
        <>
                <div className="content">
                    <Header/>
                    <Presentation/>
                    <Contact/>
                </div>

        </>
    );
};

export default HomePage;
